import { themeGet } from '@styled-system/theme-get';
import _, { max, min, uniqBy } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { Button } from '../../../components/Button/Button';
import { StyledModal } from '../../../components/StyledModal/StyledModal';

/**
 * A modal that asks the user if they're sure they want to run a recommendation given the consequences of doing so. 
 */
export const ApplyRecommendationModal = (props: {
	open: boolean;
	onCancel: () => void;
	onContinue: () => void;
}) => 
{
	return (
		<StyledModal 
			title={'Run Recommendation'}
			open={props.open} 
			onCancel={props.onCancel} 
			closable={true} 
		>
			<div>
				<span>
					Starting this process will replace any existing selections or edits for this crop. Would you like to proceed?
				</span>
				<div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						className='fieldless-modal-cancel-button'
						variant='outlined'
						style={{ marginRight: 15, width: 150 }}
						onClick={props.onCancel}
					>
						Cancel
					</Button>
					<Button
						style={{ width: 150 }}
						className='fieldless-modal-continue-button'
						variant='dark'
						onClick={props.onContinue}
					>
						Continue
					</Button>
				</div>
			</div>
		</StyledModal>
	);
};